var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'help-notice ' + _vm.noticeType},[_c('div',{staticClass:"flex"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"help-notice-message"},[_vm._t("default")],2)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shrink-0 help-notice-icon"},[_c('i',{staticClass:"fal fa-info-circle"})])
}]

export { render, staticRenderFns }